export default __webpack_public_path__ + "static/media/estafeta-inabit.163d4716.svg";